export default __webpack_public_path__ + "static/media/bot.a25221f2.webp";